import { useEffect, useState } from "react";
import { drawState } from "../../../constant/General";
import { getIndexByIncludeText, getIndexByIncludeTextAllCols, getValueByIndex } from "../../../utility/arrayUtils";
import SlotGame from "../../radom-slot/RadomStlyeSlot";


const RanderSlot = ({ index, config, currentResult, onAfterReleaseCallback, isNight, rowIndex, digit = 5 }) => {
    const [currentItem, setCurrentItem] = useState(null);
    const [drawingItem, setDrawingItem] = useState(null);
    const [drawStatus, setDrawStatus] = useState(drawState.pending);
    const defualtBg = isNight ? `ng/F${digit}.gif` : "day/F2.gif";

    const findByRow = () => {
        if (rowIndex === undefined || rowIndex === null) return null;
        const row = currentResult?.results?.[rowIndex];
        if (!row) return null;

        // KP-style row with items (multiple cols)
        if (row.items) {
            for (let col = 0; col < row.items.length; col++) {
                const colItems = row.items[col] || [];
                for (let itemIndex = 0; itemIndex < colItems.length; itemIndex++) {
                    const val = colItems[itemIndex];
                    if (typeof val === "string" && val.includes("?")) {
                        return { index: [rowIndex, col, itemIndex], value: val };
                    }
                }
            }
            return null;
        }

        // Leap/SC style: flat array or number string
        if (Array.isArray(row)) {
            for (let itemIndex = 0; itemIndex < row.length; itemIndex++) {
                const val = row[itemIndex];
                if (typeof val === "string" && val.includes("?")) {
                    return { index: [rowIndex, 0, itemIndex], value: val };
                }
            }
            return null;
        }

        if (typeof row?.number === "string" && row.number.includes("?")) {
            return { index: [rowIndex, 0, 0], value: row.number };
        }
        return null;
    }

    useEffect(() => {
        const temp = (rowIndex !== undefined && rowIndex !== null)
            ? findByRow()
            : isNight ? getIndexByIncludeTextAllCols(currentResult, "?")
                : getIndexByIncludeText(currentResult, index, "?");

        if (!currentItem) {
            setCurrentItem(temp);
        } else {
            const value = getValueByIndex(currentResult, currentItem.index);
            if (value !== drawingItem?.value && value !== "" && !value.includes("*")) {
                setDrawingItem({ value, index: currentItem.index });
                if (!value.includes("?")) {
                    setDrawStatus(drawState.release);
                } else {
                    setDrawStatus(drawState.drawing);
                }
            }
        }
        // eslint-disable-next-line
    }, [currentResult, currentItem, index, drawingItem]);

    const onDrawReleased = () => {
        onAfterReleaseCallback(index, drawingItem);
        setCurrentItem(null);
    }

    return <div className="mb-1">
        <div className="position-relative">
            {/* Slot Number */}
            <div className="absolute-center">
                {drawStatus === drawState.pending ? <div className="container text-center d-flex justify-content-center align-items-center">
                    <div
                        className="d-flex justify-content-center position-relative live-slot-background"
                        style={{
                            height: isNight ? "125px" : "94px",
                            width: isNight ? "420px" : "169px",
                            backgroundSize: "cover",
                            backgroundImage: `url(${require(`../../../assets/images/slot/${defualtBg}`)})`,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                        }}
                    />
                </div>
                    : <SlotGame
                        isNight={isNight}
                        drawStatus={drawStatus}
                        index={index}
                        onAfterReleaseCallback={onDrawReleased}
                        slot={drawingItem?.value}
                        config={config} />
                }
            </div>
        </div>
        {!isNight && <div>
            <img
                alt="Loading..."
                style={{ height: "55px" }}
                className=""
                src={require(`../../../assets/images/live-v2/kp/day/row-${index}.png`)}
            />
        </div>}
    </div>
}
export default RanderSlot;
